import { useTranslation } from 'hooks/useTranslation';

const EditorialGuide = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col">
      <h3>{t('authors.guidelines.title')}</h3>
      <div
        className="text-primary whitespace-pre-line leading-8 md:leading-normal"
        dangerouslySetInnerHTML={{ __html: t('authors.guidelines.content') }}
      />
    </div>
  );
};

export default EditorialGuide;
